import angular from 'angular';
import catalogModule from '../catalogModule';

function itemCardController($log, $scope, catalogConstants) {
  'ngInject';

  $scope.hasSecondaryInfo = () => {
    return (
      $scope.item.creatorTargetId !== catalogConstants.robloxSystemUserId ||
      $scope.item.unitsAvailableForConsumption > 0 ||
      ($scope.item.price > 0 && $scope.item.lowestPrice > 0)
    );
  };

  $scope.isCreatorNameShown = () => {
    return (
      $scope.item &&
      $scope.item.creatorTargetId !== catalogConstants.robloxSystemUserId &&
      $scope.item.creatorName
    );
  };

  $scope.isItemThumbnailLoading = () => {
    if ($scope.item.itemType === catalogConstants.itemTypes.bundle) {
      return !$scope.layout.isBundleThumbnailLoaded;
    }
    return !$scope.layout.isAssetThumbnailLoaded;
  };

  $scope.isItemThumbnailAvailable = () => {
    return $scope.item.thumbnail && $scope.item.thumbnail.imageUrl;
  };

  $scope.shouldShowPremiumIcon = () => {
    return $scope.library.isPremiumIconOnItemTilesEnabled === true && $scope.item.premiumPricing !== undefined;
  };

  $scope.getDisplayPrice = () => {
    if ($scope.library.isPremiumPriceOnItemTilesEnabled && $scope.item.premiumPricing) {
      return $scope.item.premiumPricing.premiumPriceInRobux;
    }

    return $scope.item.price;
  };

  $scope.clickItemCard = e => {
    if (!$scope.item.detailsUrl) {
      e.preventDefault();
    }
  };
}

catalogModule.controller('itemCardController', itemCardController);

export default itemCardController;
